import React from "react";
import Footer from "../../../../containers/Footer";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Whatsapp from "../../../../assets/images/icons/social/Whatsapp.svg";
import Telegram from "../../../../assets/images/icons/social/Telegram.svg";
import Instagram from "../../../../assets/images/icons/social/Instagram.svg";
import { useSelector } from "react-redux";
import Facebook from "../../../../assets/images/icons/social/facebook.svg";
import ContactUsImg from "../../../../assets/images/contactus-img2.webp";
import { Col, Container, Row } from "react-bootstrap";
import BackIcon from "../../../../assets/svg/BackIcon";
import { useNavigate } from "react-router-dom";

const AboutUs = () => {
  const navigate = useNavigate();
  const { appDetails } = useSelector((state) => state.app);
  console.log("appDetails", appDetails);

  return (
    <>
      <HeaderAfterLogin />

      <main className="main ContactUs">
        <Container>
          <div className="headingSec">
            <h4>About Us</h4>
            <div className="back-link" onClick={() => navigate(-1)}>
              <BackIcon /> Back
            </div>
          </div>
          <div className="content">
            <h5> Welcome to Worldwinbet— A New Era of Online Gaming.</h5>
            <p>
              Headquartered in Costa Rica and fully licensed by the Anjouan
              Offshore Financial Authority, Worldwinbet is one of the newest and
              most ambitious online casinos in the global market. We are a
              next-generation gaming platform designed for players who expect
              transparency, fairness, and nonstop entertainment.
            </p>
            <h5>🎲 What We Offer:</h5>

            <p className="privacy-points">
              1. Thousands of casino games from top-tier providers
            </p>
            <p className="privacy-points">
              2.Live dealer tables, slots, jackpots, and crash games
            </p>
            <p className="privacy-points">
              3. Instant crypto deposits and fast, secure withdrawals
            </p>
            <p className="privacy-points">4. 24/7 multilingual support</p>
            <p className="privacy-points">5. Seamless mobile experience</p>

            <h5>🔒 Regulated & Secure</h5>
            <p>
              We operate under an active gaming license issued in Anjouan, a
              respected offshore jurisdiction for international gaming. Our
              platform adheres to strict security protocols, player protection
              standards, and fair play policies.
            </p>
            <h5>🌍 Global Access – Local Feel</h5>
            <p>
              While we serve players from around the world, our base in Costa
              Rica ensures a stable, business-friendly infrastructure, making us
              a trusted brand in both emerging and mature gaming markets.
            </p>
            <h5>🚀 Our Mission</h5>
            <p>
              To provide an immersive, safe, and rewarding online gaming
              experience built on integrity, innovation, and community.
            </p>
          </div>
        </Container>
      </main>

      <Footer />
    </>
  );
};

export default AboutUs;
